// Nível de acesso ao Andon (coluna usuarios.andon, vinda do login e do /me).
// Espelha a regra do backend: admin sempre tem Gestão; exxer depende da coluna
// ('tv' ou 'gestao'); os demais papéis não têm acesso. Quem decide é sempre o
// backend — aqui é só para montar a interface.
import { andonMockAtivo, nivelAndonMock } from '../pages/Andon/andonDev';

export const NIVEIS_ANDON = ['tv', 'gestao'];

export const nivelAndon = (usuario) => {
  // Mock de desenvolvimento: deixa abrir a tela antes de o backend existir.
  if (andonMockAtivo() && nivelAndonMock()) return nivelAndonMock();
  if (usuario?.tipo_usuario === 'admin') return 'gestao';
  if (usuario?.tipo_usuario !== 'exxer') return null;
  return NIVEIS_ANDON.includes(usuario?.andon) ? usuario.andon : null;
};

export const temAcessoAndon = (usuario) => nivelAndon(usuario) !== null;
export const ehAndonTv = (usuario) => nivelAndon(usuario) === 'tv';

// Rota do quiosque (tela cheia, sem menu e sem topo).
export const ROTA_ANDON_TV = '/andon/tv';
export const ehRotaAndonTv = (pathname = '') => pathname.startsWith(ROTA_ANDON_TV);

// Quiosque preso: a sessão 'tv' só usa a tela da TV. Fora dela, só as telas de
// entrada (login, para trocar de usuário ou de papel, e recuperação de senha).
// O backend faz o mesmo nas rotas da API (checkRole devolve 403).
// Sessão de TV de verdade (sem o mock de desenvolvimento): é ela que prende.
export const ehSessaoTv = (usuario) => usuario?.tipo_usuario === 'exxer' && usuario?.andon === 'tv';
const ROTAS_LIVRES_NO_QUIOSQUE = ['/login', '/recuperar-senha', '/redefinir-senha/'];
export const rotaLiberadaNoQuiosque = (pathname = '') => (
  ehRotaAndonTv(pathname) || ROTAS_LIVRES_NO_QUIOSQUE.some((rota) => pathname === rota || pathname.startsWith(rota.endsWith('/') ? rota : `${rota}/`))
);
